// extracted by mini-css-extract-plugin
module.exports = {"number":"ShortenAddress_number__JLP56"};